
import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ArchiveWorkAreaItem from 'modules/locations/components/ArchivedItem'

interface Props {
  archivedCount: number
  locationId: string
}

const ArchivedElements = ({ locationId, archivedCount = 0 }: Props) => {
  const { navigation } = useNavigation()
  const tagText = i18n.tp('settings.locations.location.work_areas.archived.items', {
    count: archivedCount,
  })

  return (
    <Box
      width="full"
      paddingY="s16"
      paddingX="s24"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs004',
      }}
    >
      <ArchiveWorkAreaItem
        name={i18n.t('settings.locations.location.work_areas.archived.boxSection')}
        tagText={tagText}
      >
        <Button.Router
          to={navigation.settings.locations.locationsId.workAreasArchived.fullPath({
            id: locationId,
          })}
          type="secondary"
          iconName="arrow-right"
        />
      </ArchiveWorkAreaItem>
    </Box>
  )
}

export default ArchivedElements
